var map = {
	"./bangladesh.json": 827,
	"./cambodia.json": 828,
	"./china.json": 829,
	"./india.json": 830,
	"./italy.json": 831,
	"./myanmar.json": 832,
	"./pakistan.json": 833,
	"./portugal.json": 834,
	"./serbia-and-montenegro.json": 835,
	"./south-korea.json": 836,
	"./spain.json": 837,
	"./sri-lanka.json": 838,
	"./taiwan.json": 839,
	"./thailand.json": 840,
	"./tunisia.json": 841,
	"./turkey.json": 842,
	"./united-kingdom.json": 843,
	"./vietnam.json": 844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 826;